module.exports = __webpack_public_path__ + "static/media/logo.ba2bee30.svg";